import Page from './core/page';
import plugins from './plugins';
import Plugin from './core/plugin';

(function (root) {
    root.addEventListener('DOMContentLoaded', () => {
        for (var key in plugins) {
            new Plugin(plugins[key]);
        }
        if (!root.context) {
            root.context = {};
        }
        let page = new Page(root.context);
        let $ = page.init();
        Object.assign(root, { $ });
    });
})(window);
